export const DATE_RECURRENCE_PICKER_TAG_NAME =
  "date-recurrence-picker" as const;

export const RECURRENCE_FREQUENCIES = [
  "none",
  "daily",
  "weekly",
  "monthly",
  "yearly",
] as const;

export const RECURRENCE_TABS = [
  "daily",
  "weekly",
  "monthly",
  "yearly",
] as const;

export const RECURRENCE_WEEKDAYS = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU",
] as const;

export const RECURRENCE_WORKING_DAYS = ["MO", "TU", "WE", "TH", "FR"] as const;

export const RECURRENCE_MONTH_MODES = ["days", "position"] as const;

export const RECURRENCE_END_MODES = ["never", "until", "count"] as const;

export const RECURRENCE_POSITIONS = [1, 2, 3, 4, 5, -1] as const;

export const RECURRENCE_DAY_GROUPS = {
  day: ["MO", "TU", "WE", "TH", "FR", "SA", "SU"],
  weekday: ["MO", "TU", "WE", "TH", "FR"],
  weekendday: ["SA", "SU"],
} as const;

export const RECURRENCE_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const RECURRENCE_MONTH_DAYS = Array.from(
  { length: 31 },
  (_, index) => index + 1,
);

export const RECURRENCE_EXCEPTION_TYPES = [
  "holidays",
  "yearlydates",
  "dates",
  "weeks",
] as const;

export const RECURRENCE_VARIANTS = ["default", "link"] as const;
